import React, { useRef } from 'react';
import emailjs from 'emailjs-com'

const Contact = () => {
    const form = useRef();

    const sendEmail = (e) => {
      e.preventDefault();
      emailjs.sendForm('service_ma19pth', 'template_gph3pwc', form.current, '9E1BIFww9DMI1o7Uq')
        .then((result) => {
            alert.success('massage send')
        }, (error) => {
            console.log(error.text);
        });
        e.target.reset();
    };
    return (
        <div id="contact" className=' flex flex-col items-center justify-center mb-10'>
            <h1 className='text-5xl text-center mt-8 mb-2' 
            data-aos="fade-down"
            data-aos-duration="1500"
            data-aos-easing="ease-out-left"
            data-aos-mirror="true"
            >Contact With Me</h1>
            <form ref={form} onSubmit={sendEmail} className='flex flex-col justify-center items-center gap-2 shadow-2xl  py-8 px-4 w-full md:w-4/5 lg:w-2/5 text-gray-600 text-lg'
            data-aos="fade-up"
            data-aos-duration="1500"
            data-aos-easing="ease-out-left"
            data-aos-mirror="true"
            >
            <input type="text" name="name" placeholder='Name' className='w-full pl-4 placeholder:text-xl bg-gray-200 placeholder:text-gray-500 py-4 rounded-lg' id="" required />
            <input type="email" name="email" placeholder="Email" className='w-full placeholder:text-xl bg-gray-200 placeholder:text-gray-500 pl-4 py-4 rounded-lg ' id="" required />
            <textarea name="massage" placeholder="Massage" className='w-full placeholder:text-xl bg-gray-200 placeholder:text-gray-500 pl-4 rounded-lg' id="" cols="30" rows="10" required ></textarea>
            <button type="submit" className='btn btn-success px-10 w-full'>Send</button>
        </form>
        </div>
    );
};

export default Contact;